import type { RouteConfig } from 'vue-router';

const defaultMeta = {
  excludeLogin: true,
  background: 'transparent',
};

export default [
  /**
   * 行权
   */
  {
    path: '/vas/exercis',
    meta: {
      ...defaultMeta,
      customNavBar: true,
    },
    component: () => import('@/views/vas/exercis.vue'),
  },
  /**
   * 消息中心-挽留弹窗
   */
  {
    path: '/vas/retention',
    meta: {
      ...defaultMeta,
      customNavBar: true,
    },
    component: () => import('@/views/vas/retention.vue'),
  },
] as RouteConfig[];
